import { render, staticRenderFns } from "./BedroomCard.vue?vue&type=template&id=936757b0&"
import script from "./BedroomCard.vue?vue&type=script&lang=js&"
export * from "./BedroomCard.vue?vue&type=script&lang=js&"
import style0 from "./BedroomCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports